// extracted by mini-css-extract-plugin
export default {"success":"ConnexionStats_success__p8X9g","failed":"ConnexionStats_failed__Hp3js","holder":"ConnexionStats_holder__gd4Ay"};